export const budgetAndSpecSheetNameBuilder = (street1: string, street2: string) => {
    const combinedPropertyName = street2 ? `${street1 + ' ' + street2}` : street1;

    if (!combinedPropertyName) return '';

    return combinedPropertyName.trim();
};
